// import React, { useEffect, useMemo, useState } from "react";
// import {
//     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
//     ResponsiveContainer, Cell
// } from "recharts";
// import {
//     ShoppingBag, Utensils, ShoppingCart, Users, TrendingUp, Clock
// } from "lucide-react";
// import axios from "axios";

// const Orders = ({ isMobile }) => {

//     /* ---------------- STATE ---------------- */

//     const [stats, setStats] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);

//     /* ---------------- DEFAULT STATS ---------------- */

//     const defaultStats = {
//         totalOrders: 0,
//         todayTotalOrders: 0,
//         totalCancelledOrders: 0,
//         todayCancelledOrders: 0,
//         totalRefundedOrders: 0,
//         todayRefundedOrders: 0,
//         totalCustomers: 0,
//         todayCustomers: 0,
//         newCustomers: 0,
//         returningCustomers: 0,
//         todaySuccessRate: "0%",
//         salesGrowth: "0%",
//         paymentMethods: []
//     };

//     /* ---------------- API INTEGRATION ---------------- */

//     useEffect(() => {
//         const fetchOrdersData = async () => {
//             setLoading(true);
//             setError(null);

//             try {
//                 const token = localStorage.getItem("authToken");
//                 if (!token) {
//                     throw new Error("No auth token found. Please login.");
//                 }

//                 const response = await axios.get(
//                     "https://backend.maamaas.com/food/api/orders/admin/statistics",
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`,
//                             Accept: "application/json",
//                         },
//                     }
//                 );

//                 const apiData = response.data || {};
//                 console.log("✅ Orders API Response:", apiData);

//                 setStats(apiData);

//             } catch (err) {
//                 console.error("❌ Orders API error:", err);
//                 setError(err.message || "Failed to fetch orders data");
//                 // Set default stats on error
//                 setStats(defaultStats);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchOrdersData();
//     }, []);

//     /* ---------------- LAST 7 DAYS DATA ---------------- */

//     const dailyOrdersData = useMemo(() => {
//         const result = [];
//         const now = new Date();

//         // Create last 7 days buckets
//         for (let i = 6; i >= 0; i--) {
//             const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - i);

//             result.push({
//                 key: d.toISOString().split("T")[0],
//                 label: d.toLocaleDateString("en-IN", {
//                     day: "2-digit",
//                     month: "short"
//                 }),
//                 orders: 0,
//                 color: i % 2 === 0 ? "#f59e0b" : "#10b981"
//             });
//         }

//         // If we have stats, create simulated daily data
//         const currentStats = stats || defaultStats;
//         if (currentStats.totalOrders > 0) {
//             const baseOrders = currentStats.todayTotalOrders || currentStats.totalOrders / 30;
//             result.forEach((day, index) => {
//                 // Create realistic daily variation
//                 const dayFactor = index === 6 ? 1.2 : (index === 0 ? 0.8 : 1); // Higher on recent days
//                 const randomFactor = 0.7 + Math.random() * 0.6;
//                 day.orders = Math.floor(baseOrders * dayFactor * randomFactor);

//                 // Ensure today's orders matches API if available
//                 if (index === 6 && currentStats.todayTotalOrders) {
//                     day.orders = currentStats.todayTotalOrders;
//                 }
//             });
//         }

//         return result;
//     }, [stats]);

//     /* ---------------- SUMMARY TOTALS ---------------- */

//     const summary = useMemo(() => {
//         const currentStats = stats || defaultStats;

//         // Calculate success rate
//         const successRate = currentStats.todaySuccessRate || "0%";

//         // Calculate completed orders (total - cancelled - refunded)
//         const completedOrders = (currentStats.todayTotalOrders || 0) - 
//             (currentStats.todayCancelledOrders || 0) - 
//             (currentStats.todayRefundedOrders || 0);

//         return {
//             totalOrders: currentStats.totalOrders || 0,
//             todayTotalOrders: currentStats.todayTotalOrders || 0,
//             totalCancelledOrders: currentStats.totalCancelledOrders || 0,
//             todayCancelledOrders: currentStats.todayCancelledOrders || 0,
//             totalRefundedOrders: currentStats.totalRefundedOrders || 0,
//             todayRefundedOrders: currentStats.todayRefundedOrders || 0,
//             totalCustomers: currentStats.totalCustomers || 0,
//             todayCustomers: currentStats.todayCustomers || 0,
//             newCustomers: currentStats.newCustomers || 0,
//             returningCustomers: currentStats.returningCustomers || 0,
//             successRate,
//             completedOrders: completedOrders > 0 ? completedOrders : 0,
//             orderGrowth: currentStats.salesGrowth || "0%",
//             estimatedDelivery: Math.round(Math.random() * 10) + 15,
//             estimatedDineIn: Math.round(Math.random() * 5) + 5,
//         };
//     }, [stats]);

//     /* ---------------- ORDER TYPE DISTRIBUTION ---------------- */

//     const orderTypeDistribution = useMemo(() => {
//         const currentStats = stats || defaultStats;
//         const totalOrders = summary.totalOrders;

//         if (totalOrders === 0) {
//             return [
//                 { type: "Dine-in", value: 45, count: 0, color: "#10b981" },
//                 { type: "Delivery", value: 30, count: 0, color: "#3b82f6" },
//                 { type: "Takeaway", value: 25, count: 0, color: "#f59e0b" }
//             ];
//         }

//         // Calculate distribution based on API data (using simulated percentages)
//         return [
//             { 
//                 type: "Dine-in", 
//                 value: 45, 
//                 count: Math.round(totalOrders * 0.45), 
//                 color: "#10b981" 
//             },
//             { 
//                 type: "Delivery", 
//                 value: 30, 
//                 count: Math.round(totalOrders * 0.30), 
//                 color: "#3b82f6" 
//             },
//             { 
//                 type: "Takeaway", 
//                 value: 25, 
//                 count: Math.round(totalOrders * 0.25), 
//                 color: "#f59e0b" 
//             }
//         ];
//     }, [summary.totalOrders]);

//     /* ---------------- SUMMARY CARDS ---------------- */

//     const OrdersSummaryCards = () => {
//         if (loading) {
//             return (
//                 <div style={{ 
//                     padding: 20, 
//                     textAlign: "center", 
//                     color: "#64748b" 
//                 }}>
//                     Loading orders summary...
//                 </div>
//             );
//         }

//         if (error && !stats) {
//             return (
//                 <div style={{ 
//                     padding: 20, 
//                     textAlign: "center", 
//                     color: "#ef4444",
//                     background: "#fef2f2",
//                     borderRadius: "12px",
//                     marginBottom: "20px"
//                 }}>
//                     <h4 style={{ fontWeight: 600 }}>⚠️ Error Loading Data</h4>
//                     <p>{error}</p>
//                 </div>
//             );
//         }

//         const orderCards = [
//             {
//                 title: "Total Orders",
//                 value: summary.totalOrders?.toLocaleString("en-IN") || "0",
//                 subtitle: `${summary.completedOrders} completed today`,
//                 icon: <ShoppingBag size={18} />,
//                 bg: "linear-gradient(135deg, #fef3c7, #fde68a)",
//                 color: "#f59e0b"
//             },
//             {
//                 title: "Success Rate",
//                 value: summary.successRate,
//                 subtitle: `${summary.todayCancelledOrders} cancelled today`,
//                 icon: <TrendingUp size={18} />,
//                 bg: "linear-gradient(135deg, #dcfce7, #bbf7d0)",
//                 color: "#10b981"
//             },
//             {
//                 title: "Total Customers",
//                 value: summary.totalCustomers?.toLocaleString("en-IN") || "0",
//                 subtitle: `${summary.newCustomers} new, ${summary.returningCustomers} returning`,
//                 icon: <Users size={18} />,
//                 bg: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
//                 color: "#3b82f6"
//             },
//             {
//                 title: "Avg. Wait Time",
//                 value: `${summary.estimatedDelivery} min`,
//                 subtitle: `${summary.estimatedDineIn} min for dine-in`,
//                 icon: <Clock size={18} />,
//                 bg: "linear-gradient(135deg, #ede9fe, #ddd6fe)",
//                 color: "#8b5cf6"
//             }
//         ];

//         return (
//             <div style={{
//                 display: 'grid',
//                 gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)',
//                 gap: '12px',
//                 marginBottom: '20px'
//             }}>
//                 {orderCards.map((card, index) => (
//                     <div 
//                         key={index}
//                         style={{
//                             background: card.bg,
//                             borderRadius: '14px',
//                             padding: '16px',
//                             border: '1px solid #fff',
//                             boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
//                             display: 'flex',
//                             justifyContent: 'space-between'
//                         }}
//                     >
//                         <div>
//                             <p style={{ 
//                                 fontSize: 11, 
//                                 fontWeight: 600, 
//                                 color: '#64748b', 
//                                 marginBottom: '4px' 
//                             }}>
//                                 {card.title}
//                             </p>
//                             <p style={{ 
//                                 fontSize: isMobile ? 18 : 22, 
//                                 fontWeight: 800,
//                                 marginBottom: '4px'
//                             }}>
//                                 {card.value}
//                             </p>
//                             {card.subtitle && (
//                                 <p style={{ 
//                                     fontSize: 10, 
//                                     color: '#64748b', 
//                                     margin: 0 
//                                 }}>
//                                     {card.subtitle}
//                                 </p>
//                             )}
//                         </div>
//                         <div style={{
//                             width: 40,
//                             height: 40,
//                             borderRadius: '10px',
//                             background: `${card.color}20`,
//                             color: card.color,
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center'
//                         }}>
//                             {card.icon}
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         );
//     };

//     /* ---------------- ORDER TYPE DISTRIBUTION SUMMARY ---------------- */

//     const OrderTypeSummary = () => {
//         if (!orderTypeDistribution.length) return null;

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '16px',
//                 padding: isMobile ? '16px' : '20px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
//                 marginBottom: '20px'
//             }}>
//                 <h4 style={{ 
//                     fontWeight: 800, 
//                     marginBottom: 12, 
//                     color: '#1e293b' 
//                 }}>
//                     Order Type Distribution
//                 </h4>
//                 <div style={{ 
//                     display: 'grid', 
//                     gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
//                     gap: '10px' 
//                 }}>
//                     {orderTypeDistribution.map((type, index) => (
//                         <div
//                             key={type.type}
//                             style={{
//                                 background: `linear-gradient(135deg, ${type.color}20, ${type.color}10)`,
//                                 padding: '12px',
//                                 borderRadius: '8px',
//                                 border: `1px solid ${type.color}30`
//                             }}
//                         >
//                             <div style={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'center',
//                                 marginBottom: '8px'
//                             }}>
//                                 <p style={{ 
//                                     fontSize: 12, 
//                                     fontWeight: 600, 
//                                     margin: 0 
//                                 }}>
//                                     {type.type}
//                                 </p>
//                                 <div style={{
//                                     width: 30,
//                                     height: 30,
//                                     borderRadius: '6px',
//                                     background: `${type.color}20`,
//                                     color: type.color,
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center'
//                                 }}>
//                                     {type.type === "Dine-in" ? <Utensils size={14} /> :
//                                      type.type === "Delivery" ? <ShoppingCart size={14} /> :
//                                      <ShoppingBag size={14} />}
//                                 </div>
//                             </div>
//                             <p style={{ 
//                                 fontSize: 16, 
//                                 fontWeight: 800, 
//                                 marginBottom: '4px',
//                                 color: type.color
//                             }}>
//                                 {type.count?.toLocaleString("en-IN") || "0"}
//                             </p>
//                             <p style={{ 
//                                 fontSize: 10, 
//                                 color: '#64748b', 
//                                 margin: 0 
//                             }}>
//                                 {type.value}% of total orders
//                             </p>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         );
//     };

//     /* ---------------- CHART ---------------- */

//     const OrdersAnalysis = () => {
//         if (loading) {
//             return (
//                 <div style={{ 
//                     padding: 40, 
//                     textAlign: 'center', 
//                     color: '#64748b' 
//                 }}>
//                     Loading orders chart...
//                 </div>
//             );
//         }

//         if (error && !stats) {
//             return (
//                 <div style={{ 
//                     padding: 40, 
//                     textAlign: 'center', 
//                     color: '#ef4444',
//                     background: '#fef2f2',
//                     borderRadius: '12px',
//                     border: '1px solid #fecaca'
//                 }}>
//                     <h4 style={{ fontWeight: 600 }}>⚠️ Chart Data Unavailable</h4>
//                     <p>Unable to load orders data for chart</p>
//                 </div>
//             );
//         }

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '24px',
//                 padding: isMobile ? '20px' : '28px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)'
//             }}>
//                 <h3 style={{ 
//                     fontSize: isMobile ? 18 : 22, 
//                     fontWeight: 800, 
//                     marginBottom: 16,
//                     color: '#1e293b'
//                 }}>
//                     Daily Orders Trend (Last 7 Days)
//                 </h3>

//                 <div style={{ height: isMobile ? 280 : 360 }}>
//                     <ResponsiveContainer width="100%" height="100%">
//                         <BarChart data={dailyOrdersData}>
//                             <CartesianGrid 
//                                 strokeDasharray="3 3" 
//                                 stroke="#f1f5f9" 
//                                 vertical={false} 
//                             />
//                             <XAxis 
//                                 dataKey="label" 
//                                 stroke="#64748b"
//                                 fontSize={12}
//                             />
//                             <YAxis 
//                                 stroke="#64748b"
//                                 fontSize={12}
//                             />
//                             <Tooltip 
//                                 formatter={(value) => [`${value} orders`, "Orders"]}
//                                 labelFormatter={(label) => `Date: ${label}`}
//                                 contentStyle={{ 
//                                     borderRadius: "8px",
//                                     border: "1px solid #e2e8f0"
//                                 }}
//                             />
//                             <Bar 
//                                 dataKey="orders" 
//                                 radius={[8, 8, 0, 0]}
//                                 name="Orders"
//                             >
//                                 {dailyOrdersData.map((entry, index) => (
//                                     <Cell key={index} fill={entry.color} />
//                                 ))}
//                             </Bar>
//                         </BarChart>
//                     </ResponsiveContainer>
//                 </div>

//                 {!stats && (
//                     <div style={{ 
//                         marginTop: "16px", 
//                         fontSize: "12px", 
//                         color: "#64748b",
//                         textAlign: "center"
//                     }}>
//                         <p>Note: Daily data is simulated. Actual daily analytics coming soon.</p>
//                     </div>
//                 )}
//             </div>
//         );
//     };

//     /* ---------------- MAIN RENDER ---------------- */

//     return (
//         <>
//             <OrdersSummaryCards />
//             <OrderTypeSummary />
//             <OrdersAnalysis />
//         </>
//     );
// };

// export default Orders;
























// import React, { useMemo } from "react";
// import {
//     BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
//     ResponsiveContainer, Cell, PieChart, Pie, Legend, ComposedChart, Line
// } from "recharts";
// import {
//     ShoppingBag, Users, TrendingUp, Clock,
//     CreditCard, Wallet, DollarSign, CheckCircle, XCircle,
//     Building, Target, Percent, Calendar, Filter
// } from "lucide-react";

// const Orders = ({ isMobile, apiStats, customTotals, startDate, endDate, isCustomRangeActive, dateRangeData, colors }) => {

//     /* ---------------- FORMAT DATE ---------------- */
//     const formatDate = (dateString) => {
//         if (!dateString) return '';
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-IN', { 
//             day: 'numeric', 
//             month: 'short', 
//             year: 'numeric' 
//         });
//     };

//     /* ---------------- CALCULATE SUMMARY ---------------- */
//     const summary = useMemo(() => {
//         // If custom range is active, use custom totals
//         if (isCustomRangeActive && customTotals) {
//             const totalOrders = customTotals.orders || 0;
//             const totalRevenue = customTotals.revenue || 0;
//             const completedOrders = Math.round(totalOrders * 0.85);
//             const cancelledOrders = Math.round(totalOrders * 0.08);
//             const inProgressOrders = Math.max(0, totalOrders - completedOrders - cancelledOrders);

//             return {
//                 totalOrders,
//                 totalRevenue,
//                 completedOrders,
//                 cancelledOrders,
//                 inProgressOrders,
//                 successRate: totalOrders > 0 ? ((completedOrders / totalOrders) * 100).toFixed(1) + "%" : "0%",
//                 avgOrderValue: totalOrders > 0 ? Math.round(totalRevenue / totalOrders) : 0,
//                 allVendors: apiStats?.allVendors || [],
//                 paymentMethods: apiStats?.paymentMethods || [],
//                 topPerformingVendors: apiStats?.topPerformingVendors || [],
//                 isCustomRange: true
//             };
//         }

//         // Otherwise use API stats
//         const totalOrders = apiStats?.totalOrders || 0;
//         const totalRevenue = apiStats?.totalRevenue || 0;
//         const cancelledOrders = apiStats?.totalCancelledOrders || 0;
//         const completedOrders = Math.round(totalOrders * 0.85);
//         const inProgressOrders = Math.max(0, totalOrders - completedOrders - cancelledOrders);

//         return {
//             totalOrders,
//             totalRevenue,
//             completedOrders,
//             cancelledOrders,
//             inProgressOrders,
//             successRate: totalOrders > 0 ? ((completedOrders / totalOrders) * 100).toFixed(1) + "%" : "0%",
//             avgOrderValue: totalOrders > 0 ? Math.round(totalRevenue / totalOrders) : 0,
//             allVendors: apiStats?.allVendors || [],
//             paymentMethods: apiStats?.paymentMethods || [],
//             topPerformingVendors: apiStats?.topPerformingVendors || [],
//             isCustomRange: false
//         };
//     }, [apiStats, customTotals, isCustomRangeActive]);

//     /* ---------------- ORDER STATUS DATA ---------------- */
//     const orderStatusData = useMemo(() => {
//         const totalOrders = summary.totalOrders;

//         if (totalOrders === 0) {
//             return [
//                 { name: "Completed", value: 0, count: 0, color: "#10b981" },
//                 { name: "In Progress", value: 0, count: 0, color: "#3b82f6" },
//                 { name: "Cancelled", value: 0, count: 0, color: "#ef4444" }
//             ];
//         }

//         return [
//             { 
//                 name: "Completed", 
//                 value: Math.round((summary.completedOrders / totalOrders) * 100),
//                 count: summary.completedOrders,
//                 color: "#10b981"
//             },
//             { 
//                 name: "In Progress", 
//                 value: Math.round((summary.inProgressOrders / totalOrders) * 100),
//                 count: summary.inProgressOrders,
//                 color: "#3b82f6"
//             },
//             { 
//                 name: "Cancelled", 
//                 value: Math.round((summary.cancelledOrders / totalOrders) * 100),
//                 count: summary.cancelledOrders,
//                 color: "#ef4444"
//             }
//         ];
//     }, [summary]);

//     /* ---------------- PAYMENT METHOD DATA ---------------- */
//     const paymentMethodData = useMemo(() => {
//         if (!summary.paymentMethods.length) {
//             return [
//                 { method: "Cash", count: 0, percentage: "0%", color: "#10b981", icon: <DollarSign size={14} /> },
//                 { method: "Online", count: 0, percentage: "0%", color: "#3b82f6", icon: <CreditCard size={14} /> },
//                 { method: "Wallet", count: 0, percentage: "0%", color: "#8b5cf6", icon: <Wallet size={14} /> }
//             ];
//         }

//         return summary.paymentMethods.map(pm => ({
//             method: pm.method.replace("_", " "),
//             count: pm.count,
//             percentage: pm.percentage,
//             color: pm.method === "Cash" ? "#10b981" : 
//                    pm.method === "Online_Payment" ? "#3b82f6" : "#8b5cf6",
//             icon: pm.method === "Cash" ? <DollarSign size={14} /> :
//                   pm.method === "Online_Payment" ? <CreditCard size={14} /> :
//                   <Wallet size={14} />
//         }));
//     }, [summary.paymentMethods]);

//     /* ---------------- VENDOR DATA ---------------- */
//     const vendorData = useMemo(() => {
//         if (!summary.allVendors || summary.allVendors.length === 0) {
//             return [];
//         }

//         return summary.allVendors
//             .filter(v => v.totalOrders > 0)
//             .map(vendor => ({
//                 ...vendor,
//                 completedOrders: Math.round(vendor.totalOrders * 0.85),
//                 cancelledOrders: Math.round(vendor.totalOrders * 0.08),
//                 inProgressOrders: Math.max(0, vendor.totalOrders - Math.round(vendor.totalOrders * 0.85) - Math.round(vendor.totalOrders * 0.08)),
//                 successRate: vendor.totalOrders > 0 ? ((Math.round(vendor.totalOrders * 0.85) / vendor.totalOrders) * 100).toFixed(1) : "0.0"
//             }))
//             .sort((a, b) => b.totalOrders - a.totalOrders);
//     }, [summary.allVendors]);

//     /* ---------------- DAILY ORDERS DATA ---------------- */
//     const dailyOrdersData = useMemo(() => {
//         if (isCustomRangeActive && dateRangeData.length > 0) {
//             return dateRangeData;
//         }

//         // Default data (last 7 days)
//         const result = [];
//         const now = new Date();

//         for (let i = 6; i >= 0; i--) {
//             const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - i);
//             const orders = Math.max(10, Math.round((summary.totalOrders / 30) * (0.8 + Math.random() * 0.4)));

//             result.push({
//                 date: d.toISOString().split("T")[0],
//                 label: d.toLocaleDateString("en-IN", {
//                     day: "2-digit",
//                     month: "short"
//                 }),
//                 orders: orders,
//                 completed: Math.round(orders * 0.85),
//                 cancelled: Math.round(orders * 0.08),
//                 inProgress: Math.max(0, orders - Math.round(orders * 0.85) - Math.round(orders * 0.08)),
//                 revenue: Math.round(orders * (summary.totalRevenue / summary.totalOrders) || 50),
//                 color: i % 2 === 0 ? "#f59e0b" : "#10b981"
//             });
//         }

//         return result;
//     }, [summary, isCustomRangeActive, dateRangeData]);

//     /* ---------------- SUMMARY CARDS ---------------- */
//     const OrdersSummaryCards = () => {
//         const orderCards = [
//             {
//                 title: "Total Orders",
//                 value: summary.totalOrders?.toLocaleString("en-IN") || "0",
//                 subtitle: isCustomRangeActive ? "Custom Range" : "All Time",
//                 icon: <ShoppingBag size={18} />,
//                 bg: "linear-gradient(135deg, #fef3c7, #fde68a)",
//                 color: "#f59e0b"
//             },
//             {
//                 title: "Completed",
//                 value: summary.completedOrders?.toLocaleString("en-IN") || "0",
//                 subtitle: `${((summary.completedOrders / summary.totalOrders) * 100 || 0).toFixed(1)}% rate`,
//                 icon: <CheckCircle size={18} />,
//                 bg: "linear-gradient(135deg, #dcfce7, #bbf7d0)",
//                 color: "#10b981"
//             },
//             {
//                 title: "Avg Order Value",
//                 value: `₹${summary.avgOrderValue?.toLocaleString("en-IN") || "0"}`,
//                 subtitle: isCustomRangeActive ? "Custom Range Average" : "Overall Average",
//                 icon: <DollarSign size={18} />,
//                 bg: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
//                 color: "#3b82f6"
//             },
//             {
//                 title: "Success Rate",
//                 value: summary.successRate,
//                 subtitle: "Order Completion Rate",
//                 icon: <Target size={18} />,
//                 bg: "linear-gradient(135deg, #ede9fe, #ddd6fe)",
//                 color: "#7c3aed"
//             }
//         ];

//         return (
//             <div style={{
//                 display: 'grid',
//                 gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)',
//                 gap: '12px',
//                 marginBottom: '20px'
//             }}>
//                 {orderCards.map((card, index) => (
//                     <div 
//                         key={index}
//                         style={{
//                             background: card.bg,
//                             borderRadius: '14px',
//                             padding: '16px',
//                             border: `1px solid ${card.color}20`,
//                             boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
//                             display: 'flex',
//                             flexDirection: 'column',
//                             justifyContent: 'space-between',
//                             height: '120px',
//                             position: 'relative',
//                             overflow: 'hidden'
//                         }}
//                     >
//                         <div style={{
//                             position: 'absolute',
//                             top: '-20px',
//                             right: '-20px',
//                             width: '80px',
//                             height: '80px',
//                             background: `${card.color}10`,
//                             borderRadius: '50%',
//                             zIndex: 0
//                         }} />

//                         <div>
//                             <div style={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'flex-start',
//                                 marginBottom: '8px'
//                             }}>
//                                 <p style={{ 
//                                     fontSize: 11, 
//                                     fontWeight: 600, 
//                                     color: '#64748b', 
//                                     margin: 0,
//                                     zIndex: 1
//                                 }}>
//                                     {card.title}
//                                 </p>
//                                 <div style={{
//                                     width: 32,
//                                     height: 32,
//                                     borderRadius: '8px',
//                                     background: `${card.color}20`,
//                                     color: card.color,
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     zIndex: 1
//                                 }}>
//                                     {card.icon}
//                                 </div>
//                             </div>

//                             <p style={{ 
//                                 fontSize: isMobile ? 20 : 24, 
//                                 fontWeight: 800,
//                                 color: card.color,
//                                 margin: '4px 0',
//                                 zIndex: 1
//                             }}>
//                                 {card.value}
//                             </p>
//                         </div>

//                         {card.subtitle && (
//                             <p style={{ 
//                                 fontSize: 10, 
//                                 color: '#64748b', 
//                                 margin: 0,
//                                 zIndex: 1
//                             }}>
//                                 {card.subtitle}
//                             </p>
//                         )}
//                     </div>
//                 ))}
//             </div>
//         );
//     };

//     /* ---------------- VENDOR PERFORMANCE SECTION ---------------- */
//     const VendorPerformanceSection = () => {
//         const topVendors = vendorData.slice(0, 3);

//         if (topVendors.length === 0) return null;

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '16px',
//                 padding: '24px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
//                 marginBottom: '20px'
//             }}>
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     marginBottom: '24px'
//                 }}>
//                     <div>
//                         <h3 style={{
//                             fontSize: isMobile ? '18px' : '20px',
//                             fontWeight: 800,
//                             color: '#1e293b',
//                             margin: 0
//                         }}>
//                             Order Analytics by Restaurant
//                         </h3>
//                         <p style={{
//                             fontSize: '12px',
//                             color: '#64748b',
//                             margin: '4px 0 0 0'
//                         }}>
//                             Performance breakdown by vendor
//                         </p>
//                     </div>
//                     <div style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '8px'
//                     }}>
//                         <span style={{
//                             fontSize: '12px',
//                             color: '#64748b',
//                             background: '#f8fafc',
//                             padding: '4px 8px',
//                             borderRadius: '6px',
//                             border: '1px solid #e2e8f0'
//                         }}>
//                             Top {topVendors.length} Performing
//                         </span>
//                     </div>
//                 </div>

//                 <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
//                     gap: '16px'
//                 }}>
//                     {topVendors.map((vendor, index) => {
//                         const vendorColors = [
//                             { bg: 'linear-gradient(135deg, #fef3c7, #fde68a)', color: '#f59e0b' },
//                             { bg: 'linear-gradient(135deg, #dcfce7, #bbf7d0)', color: '#10b981' },
//                             { bg: 'linear-gradient(135deg, #e0f2fe, #bae6fd)', color: '#0ea5e9' }
//                         ][index] || { bg: 'linear-gradient(135deg, #f3f4f6, #e5e7eb)', color: '#6b7280' };

//                         return (
//                             <div
//                                 key={vendor.vendorId}
//                                 style={{
//                                     background: vendorColors.bg,
//                                     borderRadius: '12px',
//                                     padding: '20px',
//                                     border: `1px solid ${vendorColors.color}30`,
//                                     position: 'relative',
//                                     overflow: 'hidden'
//                                 }}
//                             >
//                                 {/* Vendor Header */}
//                                 <div style={{
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     alignItems: 'center',
//                                     marginBottom: '16px'
//                                 }}>
//                                     <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//                                         <div style={{
//                                             width: '44px',
//                                             height: '44px',
//                                             borderRadius: '10px',
//                                             background: `${vendorColors.color}20`,
//                                             color: vendorColors.color,
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'center',
//                                             fontSize: '16px',
//                                             fontWeight: 'bold',
//                                             border: `2px solid ${vendorColors.color}`
//                                         }}>
//                                             {vendor.vendorId}
//                                         </div>
//                                         <div>
//                                             <h4 style={{
//                                                 fontSize: '16px',
//                                                 fontWeight: 700,
//                                                 color: '#1e293b',
//                                                 margin: 0
//                                             }}>
//                                                 Vendor {vendor.vendorId}
//                                             </h4>
//                                             <p style={{
//                                                 fontSize: '12px',
//                                                 color: '#64748b',
//                                                 margin: '2px 0 0 0'
//                                             }}>
//                                                 Total Orders: {vendor.totalOrders?.toLocaleString("en-IN")}
//                                             </p>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Success Rate */}
//                                 <div style={{
//                                     background: 'white',
//                                     borderRadius: '10px',
//                                     padding: '16px',
//                                     marginBottom: '16px',
//                                     textAlign: 'center',
//                                     border: `1px solid ${vendorColors.color}20`
//                                 }}>
//                                     <p style={{
//                                         fontSize: '12px',
//                                         color: '#64748b',
//                                         margin: '0 0 8px 0',
//                                         fontWeight: 600
//                                     }}>
//                                         Success Rate
//                                     </p>
//                                     <div style={{
//                                         fontSize: '28px',
//                                         fontWeight: 800,
//                                         color: vendor.successRate >= 85 ? '#10b981' :
//                                               vendor.successRate >= 75 ? '#f59e0b' : '#ef4444',
//                                         lineHeight: 1
//                                     }}>
//                                         {vendor.successRate}%
//                                     </div>
//                                 </div>

//                                 {/* Order Breakdown */}
//                                 <div style={{
//                                     display: 'grid',
//                                     gridTemplateColumns: 'repeat(3, 1fr)',
//                                     gap: '12px',
//                                     marginBottom: '16px'
//                                 }}>
//                                     <div style={{ textAlign: 'center' }}>
//                                         <div style={{
//                                             fontSize: '18px',
//                                             fontWeight: 700,
//                                             color: "#10b981",
//                                             marginBottom: '4px'
//                                         }}>
//                                             {vendor.completedOrders}
//                                         </div>
//                                         <div style={{
//                                             fontSize: '10px',
//                                             color: '#64748b',
//                                             fontWeight: 600
//                                         }}>
//                                             Completed
//                                         </div>
//                                     </div>
//                                     <div style={{ textAlign: 'center' }}>
//                                         <div style={{
//                                             fontSize: '18px',
//                                             fontWeight: 700,
//                                             color: "#ef4444",
//                                             marginBottom: '4px'
//                                         }}>
//                                             {vendor.cancelledOrders}
//                                         </div>
//                                         <div style={{
//                                             fontSize: '10px',
//                                             color: '#64748b',
//                                             fontWeight: 600
//                                         }}>
//                                             Cancelled
//                                         </div>
//                                     </div>
//                                     <div style={{ textAlign: 'center' }}>
//                                         <div style={{
//                                             fontSize: '18px',
//                                             fontWeight: 700,
//                                             color: "#3b82f6",
//                                             marginBottom: '4px'
//                                         }}>
//                                             {vendor.inProgressOrders}
//                                         </div>
//                                         <div style={{
//                                             fontSize: '10px',
//                                             color: '#64748b',
//                                             fontWeight: 600
//                                         }}>
//                                             In Progress
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Revenue Info */}
//                                 <div style={{
//                                     background: 'rgba(255, 255, 255, 0.8)',
//                                     borderRadius: '8px',
//                                     padding: '12px',
//                                     marginBottom: '12px',
//                                     textAlign: 'center'
//                                 }}>
//                                     <p style={{
//                                         fontSize: '10px',
//                                         color: '#64748b',
//                                         margin: '0 0 4px 0'
//                                     }}>
//                                         Completed: {vendor.completedOrders} orders
//                                     </p>
//                                     <p style={{
//                                         fontSize: '12px',
//                                         fontWeight: 600,
//                                         color: vendorColors.color,
//                                         margin: 0
//                                     }}>
//                                         (₹{vendor.totalRevenue?.toLocaleString("en-IN") || "0"})
//                                     </p>
//                                 </div>

//                                 {/* Completion Ratio */}
//                                 <div style={{
//                                     textAlign: 'center',
//                                     paddingTop: '12px',
//                                     borderTop: '1px dashed #e2e8f0'
//                                 }}>
//                                     <p style={{
//                                         fontSize: '11px',
//                                         color: '#64748b',
//                                         margin: 0,
//                                         fontWeight: 600
//                                     }}>
//                                         Order Completion {vendor.completedOrders}/{vendor.totalOrders}
//                                     </p>
//                                 </div>
//                             </div>
//                         );
//                     })}
//                 </div>
//             </div>
//         );
//     };

//     /* ---------------- ORDER TREND CHART ---------------- */
//     const OrderTrendChart = () => {

//         return (
//             <div style={{
//                 background: 'white',
//                 borderRadius: '24px',
//                 padding: isMobile ? '20px' : '28px',
//                 border: '1px solid #e2e8f0',
//                 boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
//                 marginBottom: '20px'
//             }}>
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     marginBottom: '24px'
//                 }}>
//                     <div>
//                         <h3 style={{ 
//                             fontSize: isMobile ? 18 : 22, 
//                             fontWeight: 800, 
//                             color: '#1e293b',
//                             margin: 0
//                         }}>
//                             {isCustomRangeActive && startDate && endDate ? 
//                                 `Orders Trend (${formatDate(startDate)} - ${formatDate(endDate)})` :
//                                 'Daily Orders Trend (Last 7 Days)'
//                             }
//                         </h3>
//                         <p style={{
//                             fontSize: '12px',
//                             color: '#64748b',
//                             margin: '4px 0 0 0'
//                         }}>
//                             Shows daily order volume and status distribution
//                         </p>
//                     </div>

//                     {isCustomRangeActive && startDate && endDate && (
//                         <div style={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '8px',
//                             background: '#f8fafc',
//                             padding: '6px 12px',
//                             borderRadius: '8px',
//                             border: '1px solid #e2e8f0'
//                         }}>
//                             <Calendar size={14} color="#64748b" />
//                             <span style={{
//                                 fontSize: '12px',
//                                 color: '#64748b',
//                                 fontWeight: 500
//                             }}>
//                                 Custom Range
//                             </span>
//                         </div>
//                     )}
//                 </div>

//                 <div style={{ height: isMobile ? 300 : 400, width: '100%' }}>
//                     <ResponsiveContainer width="100%" height="100%">
//                         <ComposedChart
//                             data={dailyOrdersData}
//                             margin={{ top: 20, right: 20, left: 0, bottom: 20 }}
//                         >
//                             <CartesianGrid 
//                                 strokeDasharray="3 3" 
//                                 stroke="#f1f5f9" 
//                                 vertical={false}
//                             />
//                             <XAxis 
//                                 dataKey="label"
//                                 axisLine={false}
//                                 tickLine={false}
//                                 tick={{ fill: '#64748b', fontSize: 11 }}
//                                 padding={{ left: 10, right: 10 }}
//                             />
//                             <YAxis 
//                                 axisLine={false}
//                                 tickLine={false}
//                                 tick={{ fill: '#64748b', fontSize: 11 }}
//                             />
//                             <Tooltip 
//                                 contentStyle={{
//                                     borderRadius: "8px",
//                                     border: "1px solid #e2e8f0",
//                                     background: "white",
//                                     boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)"
//                                 }}
//                                 formatter={(value, name) => {
//                                     if (name === 'orders') return [value, 'Total Orders'];
//                                     if (name === 'completed') return [value, 'Completed'];
//                                     if (name === 'cancelled') return [value, 'Cancelled'];
//                                     if (name === 'inProgress') return [value, 'In Progress'];
//                                     if (name === 'revenue') return [`₹${value}`, 'Revenue'];
//                                     return [value, name];
//                                 }}
//                             />
//                             <Legend />

//                             {/* Total Orders Bar */}
//                             <Bar 
//                                 dataKey="orders" 
//                                 name="Total Orders"
//                                 fill="#7c3aed"
//                                 radius={[4, 4, 0, 0]}
//                                 barSize={20}
//                             />

//                             {/* Completed Orders Line */}
//                             <Line 
//                                 type="monotone"
//                                 dataKey="completed"
//                                 name="Completed"
//                                 stroke="#10b981"
//                                 strokeWidth={2}
//                                 dot={{ r: 3 }}
//                                 activeDot={{ r: 5 }}
//                             />
//                         </ComposedChart>
//                     </ResponsiveContainer>
//                 </div>

//                 <div style={{ 
//                     display: 'grid',
//                     gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
//                     gap: '12px',
//                     marginTop: '24px'
//                 }}>
//                     <div style={{
//                         background: '#f8fafc',
//                         padding: '12px',
//                         borderRadius: '8px',
//                         textAlign: 'center'
//                     }}>
//                         <p style={{ fontSize: '11px', color: '#64748b', margin: '0 0 4px 0' }}>
//                             Total Orders
//                         </p>
//                         <p style={{ fontSize: '16px', fontWeight: 700, color: '#7c3aed', margin: 0 }}>
//                             {dailyOrdersData.reduce((sum, item) => sum + item.orders, 0)}
//                         </p>
//                     </div>
//                     <div style={{
//                         background: '#f8fafc',
//                         padding: '12px',
//                         borderRadius: '8px',
//                         textAlign: 'center'
//                     }}>
//                         <p style={{ fontSize: '11px', color: '#64748b', margin: '0 0 4px 0' }}>
//                             Completion Rate
//                         </p>
//                         <p style={{ fontSize: '16px', fontWeight: 700, color: '#10b981', margin: 0 }}>
//                             {((dailyOrdersData.reduce((sum, item) => sum + item.completed, 0) / 
//                               dailyOrdersData.reduce((sum, item) => sum + item.orders, 1)) * 100).toFixed(1)}%
//                         </p>
//                     </div>
//                     <div style={{
//                         background: '#f8fafc',
//                         padding: '12px',
//                         borderRadius: '8px',
//                         textAlign: 'center'
//                     }}>
//                         <p style={{ fontSize: '11px', color: '#64748b', margin: '0 0 4px 0' }}>
//                             Avg Daily
//                         </p>
//                         <p style={{ fontSize: '16px', fontWeight: 700, color: '#f59e0b', margin: 0 }}>
//                             {Math.round(dailyOrdersData.reduce((sum, item) => sum + item.orders, 0) / dailyOrdersData.length)}
//                         </p>
//                     </div>
//                     <div style={{
//                         background: '#f8fafc',
//                         padding: '12px',
//                         borderRadius: '8px',
//                         textAlign: 'center'
//                     }}>
//                         <p style={{ fontSize: '11px', color: '#64748b', margin: '0 0 4px 0' }}>
//                             Period
//                         </p>
//                         <p style={{ fontSize: '16px', fontWeight: 700, color: '#3b82f6', margin: 0 }}>
//                             {dailyOrdersData.length} days
//                         </p>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     /* ---------------- ORDER STATUS & PAYMENT CHARTS ---------------- */
//     const OrderStatusAndPaymentCharts = () => {
//         return (
//             <div style={{
//                 display: 'grid',
//                 gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
//                 gap: '20px',
//                 marginBottom: '20px'
//             }}>
//                 {/* Order Status Chart */}
//                 <div style={{
//                     background: 'white',
//                     borderRadius: '16px',
//                     padding: isMobile ? '16px' : '20px',
//                     border: '1px solid #e2e8f0',
//                     boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
//                     height: 'fit-content'
//                 }}>
//                     <h4 style={{ 
//                         fontWeight: 800, 
//                         marginBottom: 16, 
//                         color: '#1e293b',
//                         textAlign: 'center'
//                     }}>
//                         Order Status Distribution
//                     </h4>

//                     <div style={{ 
//                         height: isMobile ? 250 : 300,
//                         display: 'flex',
//                         justifyContent: 'center'
//                     }}>
//                         <ResponsiveContainer width="100%" height="100%">
//                             <PieChart>
//                                 <Pie
//                                     data={orderStatusData}
//                                     cx="50%"
//                                     cy="50%"
//                                     innerRadius={isMobile ? 50 : 60}
//                                     outerRadius={isMobile ? 90 : 100}
//                                     paddingAngle={2}
//                                     dataKey="value"
//                                     label={(entry) => `${entry.name}\n${entry.value}%`}
//                                     labelLine={false}
//                                 >
//                                     {orderStatusData.map((entry, index) => (
//                                         <Cell 
//                                             key={`cell-${index}`} 
//                                             fill={entry.color}
//                                             stroke="white"
//                                             strokeWidth={2}
//                                         />
//                                     ))}
//                                 </Pie>
//                                 <Tooltip 
//                                     formatter={(value, name, props) => [
//                                         `${value}% (${props.payload.count} orders)`, 
//                                         props.payload.name
//                                     ]}
//                                 />
//                             </PieChart>
//                         </ResponsiveContainer>
//                     </div>

//                     <div style={{ 
//                         display: 'grid', 
//                         gridTemplateColumns: 'repeat(3, 1fr)',
//                         gap: '8px',
//                         marginTop: '16px'
//                     }}>
//                         {orderStatusData.map((status, index) => (
//                             <div 
//                                 key={index} 
//                                 style={{ 
//                                     textAlign: 'center',
//                                     padding: '8px',
//                                     background: `${status.color}10`,
//                                     borderRadius: '8px',
//                                     border: `1px solid ${status.color}20`
//                                 }}
//                             >
//                                 <div style={{ 
//                                     width: '12px',
//                                     height: '12px',
//                                     borderRadius: '50%',
//                                     backgroundColor: status.color,
//                                     margin: '0 auto 6px'
//                                 }} />
//                                 <p style={{ 
//                                     fontSize: '12px', 
//                                     fontWeight: 600,
//                                     color: '#1e293b',
//                                     margin: '0 0 2px 0'
//                                 }}>
//                                     {status.name}
//                                 </p>
//                                 <p style={{ 
//                                     fontSize: '14px', 
//                                     fontWeight: 700,
//                                     color: status.color,
//                                     margin: 0
//                                 }}>
//                                     {status.count}
//                                 </p>
//                                 <p style={{ 
//                                     fontSize: '10px', 
//                                     color: '#64748b', 
//                                     margin: '2px 0 0 0'
//                                 }}>
//                                     {status.value}%
//                                 </p>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* Payment Methods Chart */}
//                 <div style={{
//                     background: 'white',
//                     borderRadius: '16px',
//                     padding: isMobile ? '16px' : '20px',
//                     border: '1px solid #e2e8f0',
//                     boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
//                 }}>
//                     <h4 style={{ 
//                         fontWeight: 800, 
//                         marginBottom: 16, 
//                         color: '#1e293b',
//                         textAlign: 'center'
//                     }}>
//                         Payment Methods
//                     </h4>

//                     <div style={{ 
//                         height: isMobile ? 200 : 250,
//                         display: 'flex',
//                         justifyContent: 'center'
//                     }}>
//                         <ResponsiveContainer width="100%" height="100%">
//                             <BarChart
//                                 data={paymentMethodData}
//                                 layout="vertical"
//                                 margin={{ top: 20, right: 30, left: 40, bottom: 5 }}
//                             >
//                                 <CartesianGrid 
//                                     strokeDasharray="3 3" 
//                                     stroke="#f1f5f9"
//                                     horizontal={false}
//                                 />
//                                 <XAxis 
//                                     type="number"
//                                     axisLine={false}
//                                     tickLine={false}
//                                     tick={{ fill: '#64748b', fontSize: 11 }}
//                                 />
//                                 <YAxis 
//                                     type="category"
//                                     dataKey="method"
//                                     axisLine={false}
//                                     tickLine={false}
//                                     tick={{ fill: '#64748b', fontSize: 12 }}
//                                     width={80}
//                                 />
//                                 <Tooltip 
//                                     formatter={(value, name, props) => {
//                                         if (name === 'count') return [value, 'Orders'];
//                                         if (name === 'percentage') return [value, 'Percentage'];
//                                         return [value, name];
//                                     }}
//                                 />
//                                 <Bar 
//                                     dataKey="count" 
//                                     name="Order Count"
//                                     radius={[0, 4, 4, 0]}
//                                     barSize={20}
//                                 >
//                                     {paymentMethodData.map((entry, index) => (
//                                         <Cell key={`cell-${index}`} fill={entry.color} />
//                                     ))}
//                                 </Bar>
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </div>

//                     <div style={{ 
//                         display: 'grid', 
//                         gridTemplateColumns: 'repeat(3, 1fr)',
//                         gap: '12px',
//                         marginTop: '24px'
//                     }}>
//                         {paymentMethodData.map((method, index) => (
//                             <div
//                                 key={method.method}
//                                 style={{
//                                     background: `linear-gradient(135deg, ${method.color}10, ${method.color}05)`,
//                                     padding: '12px',
//                                     borderRadius: '10px',
//                                     border: `1px solid ${method.color}20`,
//                                     textAlign: 'center'
//                                 }}
//                             >
//                                 <div style={{
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     width: '32px',
//                                     height: '32px',
//                                     borderRadius: '8px',
//                                     background: `${method.color}20`,
//                                     color: method.color,
//                                     marginBottom: '8px'
//                                 }}>
//                                     {method.icon}
//                                 </div>
//                                 <p style={{ 
//                                     fontSize: '12px', 
//                                     fontWeight: 600, 
//                                     color: '#1e293b',
//                                     margin: '0 0 4px 0'
//                                 }}>
//                                     {method.method}
//                                 </p>
//                                 <p style={{ 
//                                     fontSize: '14px', 
//                                     fontWeight: 700, 
//                                     marginBottom: '2px',
//                                     color: method.color
//                                 }}>
//                                     {method.count?.toLocaleString("en-IN") || "0"}
//                                 </p>
//                                 <p style={{ 
//                                     fontSize: '11px', 
//                                     color: '#64748b', 
//                                     margin: 0
//                                 }}>
//                                     {method.percentage}
//                                 </p>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     /* ---------------- MAIN RENDER ---------------- */
//     return (
//         <div>
//             <OrdersSummaryCards />
//             <VendorPerformanceSection />
//             <OrderStatusAndPaymentCharts />
//             <OrderTrendChart />
//         </div>
//     );
// };

// export default Orders;





















import React, { useMemo } from "react";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
    ResponsiveContainer, Cell, PieChart, Pie, Legend, ComposedChart, Line
} from "recharts";
import {
    ShoppingBag, Users, TrendingUp, Clock,
    CreditCard, Wallet, DollarSign, CheckCircle, XCircle,
    Building, Target, Percent, Calendar, Filter
} from "lucide-react";

const Orders = ({ isMobile, apiStats, customTotals, startDate, endDate, isCustomRangeActive, dateRangeData, colors }) => {

    /* ---------------- FORMAT DATE ---------------- */
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    /* ---------------- CALCULATE SUMMARY ---------------- */
    const summary = useMemo(() => {
        // If custom range is active, use custom totals
        if (isCustomRangeActive && customTotals) {
            const totalOrders = customTotals.orders || 0;
            const totalRevenue = customTotals.revenue || 0;
            const completedOrders = totalOrders - (customTotals.cancelledOrders || 0);
            const cancelledOrders = customTotals.cancelledOrders || 0;
            const inProgressOrders = 0; // Assuming no in-progress in custom data

            return {
                totalOrders,
                totalRevenue,
                completedOrders,
                cancelledOrders,
                inProgressOrders,
                successRate: totalOrders > 0 ? ((completedOrders / totalOrders) * 100).toFixed(1) + "%" : "0%",
                avgOrderValue: totalOrders > 0 ? Math.round(totalRevenue / totalOrders) : 0,
                allVendors: apiStats?.allVendors || [],
                paymentMethods: apiStats?.paymentMethods || [],
                topPerformingVendors: apiStats?.topPerformingVendors || [],
                isCustomRange: true
            };
        }

        // Otherwise use API stats
        const totalOrders = apiStats?.totalOrders || 0;
        const totalRevenue = apiStats?.totalRevenue || 0;
        const cancelledOrders = apiStats?.totalCancelledOrders || 0;
        const completedOrders = totalOrders - cancelledOrders; // Assuming remaining are completed
        const inProgressOrders = 0; // No in-progress data in API

        return {
            totalOrders,
            totalRevenue,
            completedOrders,
            cancelledOrders,
            inProgressOrders,
            successRate: totalOrders > 0 ? ((completedOrders / totalOrders) * 100).toFixed(1) + "%" : "0%",
            avgOrderValue: totalOrders > 0 ? Math.round(totalRevenue / totalOrders) : 0,
            allVendors: apiStats?.allVendors || [],
            paymentMethods: apiStats?.paymentMethods || [],
            topPerformingVendors: apiStats?.topPerformingVendors || [],
            isCustomRange: false
        };
    }, [apiStats, customTotals, isCustomRangeActive]);

    /* ---------------- ORDER STATUS DATA ---------------- */
    const orderStatusData = useMemo(() => {
        const totalOrders = summary.totalOrders;

        if (totalOrders === 0) {
            return [
                { name: "Completed", value: 0, count: 0, color: "#10b981" },
                { name: "Cancelled", value: 0, count: 0, color: "#ef4444" }
            ];
        }

        const completedPercentage = (summary.completedOrders / totalOrders) * 100;
        const cancelledPercentage = (summary.cancelledOrders / totalOrders) * 100;

        return [
            {
                name: "Completed",
                value: Math.round(completedPercentage),
                count: summary.completedOrders,
                color: "#10b981"
            },
            {
                name: "Cancelled",
                value: Math.round(cancelledPercentage),
                count: summary.cancelledOrders,
                color: "#ef4444"
            }
        ];
    }, [summary]);

    /* ---------------- PAYMENT METHOD DATA ---------------- */
    const paymentMethodData = useMemo(() => {
        if (!summary.paymentMethods.length) {
            return [
                { method: "Cash", count: 0, percentage: "0%", color: "#10b981", icon: <DollarSign size={14} /> },
                { method: "Online Payment", count: 0, percentage: "0%", color: "#3b82f6", icon: <CreditCard size={14} /> },
                { method: "Maamaas Wallet", count: 0, percentage: "0%", color: "#8b5cf6", icon: <Wallet size={14} /> }
            ];
        }

        return summary.paymentMethods.map(pm => ({
            method: pm.method === "Cash" ? "Cash" :
                pm.method === "Online_Payment" ? "Online Payment" : "Maamaas Wallet",
            count: pm.count,
            percentage: pm.percentage,
            color: pm.method === "Cash" ? "#10b981" :
                pm.method === "Online_Payment" ? "#3b82f6" : "#8b5cf6",
            icon: pm.method === "Cash" ? <DollarSign size={14} /> :
                pm.method === "Online_Payment" ? <CreditCard size={14} /> :
                    <Wallet size={14} />
        }));
    }, [summary.paymentMethods]);

    /* ---------------- VENDOR DATA ---------------- */
    const vendorData = useMemo(() => {
        if (!summary.allVendors || summary.allVendors.length === 0) {
            return [];
        }

        return summary.allVendors
            .filter(v => v.totalOrders > 0)
            .map(vendor => ({
                ...vendor,
                // For each vendor, calculate completed orders (total - cancelled)
                // We don't have vendor-specific cancelled counts, so using overall average
                cancelledOrders: Math.round(vendor.totalOrders * (summary.cancelledOrders / summary.totalOrders)) || 0,
                completedOrders: vendor.totalOrders - Math.round(vendor.totalOrders * (summary.cancelledOrders / summary.totalOrders)) || 0,
                inProgressOrders: 0,
                // Calculate success rate based on completed orders
                successRate: vendor.totalOrders > 0 ?
                    ((vendor.totalOrders - (Math.round(vendor.totalOrders * (summary.cancelledOrders / summary.totalOrders)) || 0)) / vendor.totalOrders * 100).toFixed(1) : "0.0"
            }))
            .sort((a, b) => b.totalOrders - a.totalOrders);
    }, [summary.allVendors, summary.cancelledOrders, summary.totalOrders]);

    /* ---------------- DAILY ORDERS DATA ---------------- */
    const dailyOrdersData = useMemo(() => {
        if (isCustomRangeActive && dateRangeData.length > 0) {
            return dateRangeData;
        }

        // Default data (last 7 days) based on actual stats
        const result = [];
        const now = new Date();

        // Calculate average daily orders from total
        const avgDailyOrders = Math.round(summary.totalOrders / 30); // Assuming 30 days of data

        for (let i = 6; i >= 0; i--) {
            const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - i);
            const orders = Math.max(5, Math.round(avgDailyOrders * (0.8 + Math.random() * 0.4)));
            const cancelled = Math.round(orders * (summary.cancelledOrders / summary.totalOrders));
            const completed = orders - cancelled;

            result.push({
                date: d.toISOString().split("T")[0],
                label: d.toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short"
                }),
                orders: orders,
                completed: completed,
                cancelled: cancelled,
                inProgress: 0,
                revenue: Math.round(orders * (summary.avgOrderValue || 50)),
                color: i % 2 === 0 ? "#f59e0b" : "#10b981"
            });
        }

        return result;
    }, [summary, isCustomRangeActive, dateRangeData]);

    /* ---------------- SUMMARY CARDS ---------------- */
    const OrdersSummaryCards = () => {
        const orderCards = [
            {
                title: "Total Orders",
                value: summary.totalOrders?.toLocaleString("en-IN") || "0",
                subtitle: isCustomRangeActive ? "Custom Range" : "All Time",
                icon: <ShoppingBag size={18} />,
                bg: "linear-gradient(135deg, #fef3c7, #fde68a)",
                color: "#f59e0b"
            },
            {
                title: "Completed",
                value: summary.completedOrders?.toLocaleString("en-IN") || "0",
                subtitle: `${((summary.completedOrders / summary.totalOrders) * 100 || 0).toFixed(1)}% of total`,
                icon: <CheckCircle size={18} />,
                bg: "linear-gradient(135deg, #dcfce7, #bbf7d0)",
                color: "#10b981"
            },
            {
                title: "Avg Order Value",
                value: `₹${summary.avgOrderValue?.toLocaleString("en-IN") || "0"}`,
                subtitle: isCustomRangeActive ? "Custom Range Average" : "Overall Average",
                icon: (
                    <span style={{ fontSize: isMobile ? 16 : 18, fontWeight: 700 }}>
                        ₹
                    </span>
                ),

                bg: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
                color: "#3b82f6"
            },
            {
                title: "Success Rate",
                value: summary.successRate,
                subtitle: "Order Completion Rate",
                icon: <Target size={18} />,
                bg: "linear-gradient(135deg, #ede9fe, #ddd6fe)",
                color: "#7c3aed"
            }
        ];

        return (
            <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)',
                gap: '12px',
                marginBottom: '20px',
                marginTop: "-28px"
            }}>
                {orderCards.map((card, index) => (
                    <div
                        key={index}
                        style={{
                            background: card.bg,
                            borderRadius: '14px',
                            padding: '16px',
                            border: `1px solid ${card.color}20`,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: '120px',
                            position: 'relative',
                            overflow: 'hidden'
                        }}
                    >
                        <div style={{
                            position: 'absolute',
                            top: '-20px',
                            right: '-20px',
                            width: '80px',
                            height: '80px',
                            background: `${card.color}10`,
                            borderRadius: '50%',
                            zIndex: 0
                        }} />

                        <div>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                marginBottom: '8px'
                            }}>
                                <p style={{
                                    fontSize: 11,
                                    fontWeight: 600,
                                    color: '#64748b',
                                    margin: 0,
                                    zIndex: 1
                                }}>
                                    {card.title}
                                </p>
                                <div style={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: '8px',
                                    background: `${card.color}20`,
                                    color: card.color,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 1
                                }}>
                                    {card.icon}
                                </div>
                            </div>

                            <p style={{
                                fontSize: isMobile ? 20 : 24,
                                fontWeight: 800,
                                color: card.color,
                                margin: '4px 0',
                                zIndex: 1
                            }}>
                                {card.value}
                            </p>
                        </div>

                        {card.subtitle && (
                            <p style={{
                                fontSize: 10,
                                color: '#64748b',
                                margin: 0,
                                zIndex: 1
                            }}>
                                {card.subtitle}
                            </p>
                        )}
                    </div>
                ))}
            </div>
        );
    };

    /* ---------------- VENDOR PERFORMANCE SECTION ---------------- */
    const VendorPerformanceSection = () => {
        const topVendors = vendorData.slice(0, 3);

        if (topVendors.length === 0) return null;

        return (
            <div style={{
                background: 'white',
                borderRadius: '16px',
                padding: '24px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                marginBottom: '20px'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '24px'
                }}>
                    <div>
                        <h3 style={{
                            fontSize: isMobile ? '18px' : '20px',
                            fontWeight: 800,
                            color: '#1e293b',
                            margin: 0
                        }}>
                            Order Analytics by Restaurant
                        </h3>
                        <p style={{
                            fontSize: '12px',
                            color: '#64748b',
                            margin: '4px 0 0 0'
                        }}>
                            Performance breakdown by vendor
                        </p>
                    </div>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <span style={{
                            fontSize: '12px',
                            color: '#64748b',
                            background: '#f8fafc',
                            padding: '4px 8px',
                            borderRadius: '6px',
                            border: '1px solid #e2e8f0'
                        }}>
                            Top {topVendors.length} Performing
                        </span>
                    </div>
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                    gap: '16px'
                }}>
                    {topVendors.map((vendor, index) => {
                        const vendorColors = [
                            { bg: 'linear-gradient(135deg, #fef3c7, #fde68a)', color: '#f59e0b' },
                            { bg: 'linear-gradient(135deg, #dcfce7, #bbf7d0)', color: '#10b981' },
                            { bg: 'linear-gradient(135deg, #e0f2fe, #bae6fd)', color: '#0ea5e9' }
                        ][index] || { bg: 'linear-gradient(135deg, #f3f4f6, #e5e7eb)', color: '#6b7280' };

                        return (
                            <div
                                key={vendor.vendorId}
                                style={{
                                    background: vendorColors.bg,
                                    borderRadius: '12px',
                                    padding: '20px',
                                    border: `1px solid ${vendorColors.color}30`,
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}
                            >
                                {/* Vendor Header */}
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '16px'
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                        <div style={{
                                            width: '44px',
                                            height: '44px',
                                            borderRadius: '10px',
                                            background: `${vendorColors.color}20`,
                                            color: vendorColors.color,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            border: `2px solid ${vendorColors.color}`
                                        }}>
                                            {vendor.vendorId}
                                        </div>
                                        <div>
                                            <h4 style={{
                                                fontSize: '16px',
                                                fontWeight: 700,
                                                color: '#1e293b',
                                                margin: 0
                                            }}>
                                                Vendor {vendor.vendorId}
                                            </h4>
                                            <p style={{
                                                fontSize: '12px',
                                                color: '#64748b',
                                                margin: '2px 0 0 0'
                                            }}>
                                                Total Orders: {vendor.totalOrders?.toLocaleString("en-IN")}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Success Rate */}
                                <div style={{
                                    background: 'white',
                                    borderRadius: '10px',
                                    padding: '16px',
                                    marginBottom: '16px',
                                    textAlign: 'center',
                                    border: `1px solid ${vendorColors.color}20`
                                }}>
                                    <p style={{
                                        fontSize: '12px',
                                        color: '#64748b',
                                        margin: '0 0 8px 0',
                                        fontWeight: 600
                                    }}>
                                        Success Rate
                                    </p>
                                    <div style={{
                                        fontSize: '28px',
                                        fontWeight: 800,
                                        color: vendor.successRate >= 85 ? '#10b981' :
                                            vendor.successRate >= 75 ? '#f59e0b' : '#ef4444',
                                        lineHeight: 1
                                    }}>
                                        {vendor.successRate}%
                                    </div>
                                </div>

                                {/* Order Breakdown */}
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                    gap: '12px',
                                    marginBottom: '16px'
                                }}>
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{
                                            fontSize: '18px',
                                            fontWeight: 700,
                                            color: "#10b981",
                                            marginBottom: '4px'
                                        }}>
                                            {vendor.completedOrders}
                                        </div>
                                        <div style={{
                                            fontSize: '10px',
                                            color: '#64748b',
                                            fontWeight: 600
                                        }}>
                                            Completed
                                        </div>
                                    </div>
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{
                                            fontSize: '18px',
                                            fontWeight: 700,
                                            color: "#ef4444",
                                            marginBottom: '4px'
                                        }}>
                                            {vendor.cancelledOrders}
                                        </div>
                                        <div style={{
                                            fontSize: '10px',
                                            color: '#64748b',
                                            fontWeight: 600
                                        }}>
                                            Cancelled
                                        </div>
                                    </div>
                                </div>

                                {/* Revenue Info */}
                                <div style={{
                                    background: 'rgba(255, 255, 255, 0.8)',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    marginBottom: '12px',
                                    textAlign: 'center'
                                }}>
                                    <p style={{
                                        fontSize: '10px',
                                        color: '#64748b',
                                        margin: '0 0 4px 0'
                                    }}>
                                        Completed: {vendor.completedOrders} orders
                                    </p>
                                    <p style={{
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        color: vendorColors.color,
                                        margin: 0
                                    }}>
                                        ₹{vendor.totalRevenue?.toLocaleString("en-IN") || "0"}
                                    </p>
                                </div>

                                {/* Completion Ratio */}
                                <div style={{
                                    textAlign: 'center',
                                    paddingTop: '12px',
                                    borderTop: '1px dashed #e2e8f0'
                                }}>
                                    <p style={{
                                        fontSize: '11px',
                                        color: '#64748b',
                                        margin: 0,
                                        fontWeight: 600
                                    }}>
                                        Order Completion {vendor.completedOrders}/{vendor.totalOrders}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    /* ---------------- ORDER TREND CHART ---------------- */
    const OrderTrendChart = () => {

        return (
            <div style={{
                background: 'white',
                borderRadius: '24px',
                padding: isMobile ? '20px' : '28px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
                marginBottom: '20px'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '24px'
                }}>
                    <div>
                        <h3 style={{
                            fontSize: isMobile ? 18 : 22,
                            fontWeight: 800,
                            color: '#1e293b',
                            margin: 0
                        }}>
                            {isCustomRangeActive && startDate && endDate ?
                                `Orders Trend (${formatDate(startDate)} - ${formatDate(endDate)})` :
                                'Daily Orders Trend (Last 7 Days)'
                            }
                        </h3>
                        <p style={{
                            fontSize: '12px',
                            color: '#64748b',
                            margin: '4px 0 0 0'
                        }}>
                            Shows daily order volume and status distribution
                        </p>
                    </div>

                    {isCustomRangeActive && startDate && endDate && (
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            background: '#f8fafc',
                            padding: '6px 12px',
                            borderRadius: '8px',
                            border: '1px solid #e2e8f0'
                        }}>
                            <Calendar size={14} color="#64748b" />
                            <span style={{
                                fontSize: '12px',
                                color: '#64748b',
                                fontWeight: 500
                            }}>
                                Custom Range
                            </span>
                        </div>
                    )}
                </div>

                <div style={{ height: isMobile ? 300 : 400, width: '100%' }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <ComposedChart
                            data={dailyOrdersData}
                            margin={{ top: 20, right: 20, left: 0, bottom: 20 }}
                        >
                            <CartesianGrid
                                strokeDasharray="3 3"
                                stroke="#f1f5f9"
                                vertical={false}
                            />
                            <XAxis
                                dataKey="label"
                                axisLine={false}
                                tickLine={false}
                                tick={{ fill: '#64748b', fontSize: 11 }}
                                padding={{ left: 10, right: 10 }}
                            />
                            <YAxis
                                axisLine={false}
                                tickLine={false}
                                tick={{ fill: '#64748b', fontSize: 11 }}
                            />
                            <Tooltip
                                contentStyle={{
                                    borderRadius: "8px",
                                    border: "1px solid #e2e8f0",
                                    background: "white",
                                    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)"
                                }}
                                formatter={(value, name) => {
                                    if (name === 'orders') return [value, 'Total Orders'];
                                    if (name === 'completed') return [value, 'Completed'];
                                    if (name === 'cancelled') return [value, 'Cancelled'];
                                    if (name === 'revenue') return [`₹${value}`, 'Revenue'];
                                    return [value, name];
                                }}
                            />
                            <Legend />

                            {/* Total Orders Bar */}
                            <Bar
                                dataKey="orders"
                                name="Total Orders"
                                fill="#7c3aed"
                                radius={[4, 4, 0, 0]}
                                barSize={20}
                            />

                            {/* Completed Orders Line */}
                            <Line
                                type="monotone"
                                dataKey="completed"
                                name="Completed"
                                stroke="#10b981"
                                strokeWidth={2}
                                dot={{ r: 3 }}
                                activeDot={{ r: 5 }}
                            />
                        </ComposedChart>
                    </ResponsiveContainer>
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                    gap: '12px',
                    marginTop: '24px'
                }}>
                    <div style={{
                        background: '#f8fafc',
                        padding: '12px',
                        borderRadius: '8px',
                        textAlign: 'center'
                    }}>
                        <p style={{ fontSize: '11px', color: '#64748b', margin: '0 0 4px 0' }}>
                            Total Orders
                        </p>
                        <p style={{ fontSize: '16px', fontWeight: 700, color: '#7c3aed', margin: 0 }}>
                            {dailyOrdersData.reduce((sum, item) => sum + item.orders, 0)}
                        </p>
                    </div>
                    <div style={{
                        background: '#f8fafc',
                        padding: '12px',
                        borderRadius: '8px',
                        textAlign: 'center'
                    }}>
                        <p style={{ fontSize: '11px', color: '#64748b', margin: '0 0 4px 0' }}>
                            Completion Rate
                        </p>
                        <p style={{ fontSize: '16px', fontWeight: 700, color: '#10b981', margin: 0 }}>
                            {((dailyOrdersData.reduce((sum, item) => sum + item.completed, 0) /
                                dailyOrdersData.reduce((sum, item) => sum + item.orders, 1)) * 100).toFixed(1)}%
                        </p>
                    </div>
                    <div style={{
                        background: '#f8fafc',
                        padding: '12px',
                        borderRadius: '8px',
                        textAlign: 'center'
                    }}>
                        <p style={{ fontSize: '11px', color: '#64748b', margin: '0 0 4px 0' }}>
                            Avg Daily
                        </p>
                        <p style={{ fontSize: '16px', fontWeight: 700, color: '#f59e0b', margin: 0 }}>
                            {Math.round(dailyOrdersData.reduce((sum, item) => sum + item.orders, 0) / dailyOrdersData.length)}
                        </p>
                    </div>
                    <div style={{
                        background: '#f8fafc',
                        padding: '12px',
                        borderRadius: '8px',
                        textAlign: 'center'
                    }}>
                        <p style={{ fontSize: '11px', color: '#64748b', margin: '0 0 4px 0' }}>
                            Period
                        </p>
                        <p style={{ fontSize: '16px', fontWeight: 700, color: '#3b82f6', margin: 0 }}>
                            {dailyOrdersData.length} days
                        </p>
                    </div>
                </div>
            </div>
        );
    };

    /* ---------------- ORDER STATUS & PAYMENT CHARTS ---------------- */
    const OrderStatusAndPaymentCharts = () => {
        return (
            <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                gap: '20px',
                marginBottom: '20px'
            }}>
                {/* Order Status Chart */}
                <div style={{
                    background: 'white',
                    borderRadius: '16px',
                    padding: isMobile ? '16px' : '20px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                    height: 'fit-content'
                }}>
                    <h4 style={{
                        fontWeight: 800,
                        marginBottom: 16,
                        color: '#1e293b',
                        textAlign: 'center'
                    }}>
                        Order Status Distribution
                    </h4>

                    <div style={{
                        height: isMobile ? 250 : 300,
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie
                                    data={orderStatusData}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={isMobile ? 50 : 60}
                                    outerRadius={isMobile ? 90 : 100}
                                    paddingAngle={2}
                                    dataKey="value"
                                    label={(entry) => `${entry.name}\n${entry.value}%`}
                                    labelLine={false}
                                >
                                    {orderStatusData.map((entry, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={entry.color}
                                            stroke="white"
                                            strokeWidth={2}
                                        />
                                    ))}
                                </Pie>
                                <Tooltip
                                    formatter={(value, name, props) => [
                                        `${value}% (${props.payload.count} orders)`,
                                        props.payload.name
                                    ]}
                                />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        gap: '8px',
                        marginTop: '16px'
                    }}>
                        {orderStatusData.map((status, index) => (
                            <div
                                key={index}
                                style={{
                                    textAlign: 'center',
                                    padding: '8px',
                                    background: `${status.color}10`,
                                    borderRadius: '8px',
                                    border: `1px solid ${status.color}20`
                                }}
                            >
                                <div style={{
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    backgroundColor: status.color,
                                    margin: '0 auto 6px'
                                }} />
                                <p style={{
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: '#1e293b',
                                    margin: '0 0 2px 0'
                                }}>
                                    {status.name}
                                </p>
                                <p style={{
                                    fontSize: '14px',
                                    fontWeight: 700,
                                    color: status.color,
                                    margin: 0
                                }}>
                                    {status.count}
                                </p>
                                <p style={{
                                    fontSize: '10px',
                                    color: '#64748b',
                                    margin: '2px 0 0 0'
                                }}>
                                    {status.value}%
                                </p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Payment Methods Chart */}
                <div style={{
                    background: 'white',
                    borderRadius: '16px',
                    padding: isMobile ? '16px' : '20px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>
                    <h4 style={{
                        fontWeight: 800,
                        marginBottom: 16,
                        color: '#1e293b',
                        textAlign: 'center'
                    }}>
                        Payment Methods
                    </h4>

                    <div style={{
                        height: isMobile ? 200 : 250,
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart
                                data={paymentMethodData}
                                layout="vertical"
                                margin={{ top: 20, right: 30, left: 40, bottom: 5 }}
                            >
                                <CartesianGrid
                                    strokeDasharray="3 3"
                                    stroke="#f1f5f9"
                                    horizontal={false}
                                />
                                <XAxis
                                    type="number"
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fill: '#64748b', fontSize: 11 }}
                                />
                                <YAxis
                                    type="category"
                                    dataKey="method"
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fill: '#64748b', fontSize: 12 }}
                                    width={80}
                                />
                                <Tooltip
                                    formatter={(value, name, props) => {
                                        if (name === 'count') return [value, 'Orders'];
                                        if (name === 'percentage') return [value, 'Percentage'];
                                        return [value, name];
                                    }}
                                />
                                <Bar
                                    dataKey="count"
                                    name="Order Count"
                                    radius={[0, 4, 4, 0]}
                                    barSize={20}
                                >
                                    {paymentMethodData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                    ))}
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: '12px',
                        marginTop: '24px'
                    }}>
                        {paymentMethodData.map((method, index) => (
                            <div
                                key={method.method}
                                style={{
                                    background: `linear-gradient(135deg, ${method.color}10, ${method.color}05)`,
                                    padding: '12px',
                                    borderRadius: '10px',
                                    border: `1px solid ${method.color}20`,
                                    textAlign: 'center'
                                }}
                            >
                                <div style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '8px',
                                    background: `${method.color}20`,
                                    color: method.color,
                                    marginBottom: '8px'
                                }}>
                                    {method.icon}
                                </div>
                                <p style={{
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: '#1e293b',
                                    margin: '0 0 4px 0'
                                }}>
                                    {method.method}
                                </p>
                                <p style={{
                                    fontSize: '14px',
                                    fontWeight: 700,
                                    marginBottom: '2px',
                                    color: method.color
                                }}>
                                    {method.count?.toLocaleString("en-IN") || "0"}
                                </p>
                                <p style={{
                                    fontSize: '11px',
                                    color: '#64748b',
                                    margin: 0
                                }}>
                                    {method.percentage}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    /* ---------------- MAIN RENDER ---------------- */
    return (
        <div>
            <OrdersSummaryCards />
            <VendorPerformanceSection />
            <OrderStatusAndPaymentCharts />
            <OrderTrendChart />
        </div>
    );
};

export default Orders;